/* PagingTargetResultsFeed.js */

const PagingFeed = require("../../../../lib/PagingFeed");

class PagingTargetResultsFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startRelatedResultsFeed(this._filter, this._entityFields, this._sort, { skip: 0, limit: this._pageSize * 2 });
    }

    _getDistinctValuesOfField(tenantId, field) {
        return this._EntityDef.startWorkDistinctValuesFeed(tenantId, field, {});
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadWorkIdsForSelection(tenantId, selection);
    }

    getWorkEntitiesById(ids) {
        return this.getEntitiesById(ids);
    }

    getWorkEntitiesNameById(ids) {
        return this.getEntitiesNameById(ids);
    }

    getWorkEntityById(id) {
        return this.getEntityById(id);
    }
}

module.exports = PagingTargetResultsFeed;
